// MOISSANITE_V43_CATEGORY_IMAGES
// MOISSANITE_V3_2_HERO
import { useStore } from '@/context/StoreContext';
import { MEDIA } from '@/data/site';
import { ProductCard } from '@/components/products/ProductCard';
import { navigate } from '@/hooks/useRoute';
import { pickDiverseCuratedProducts } from '@/utils/curatedSelection';
import type { Product } from '@/types/product';
import '../moissanite-premium-v3.css';
import './HomePage.v12-0-luxury-story.css';
import { FirstPurchasePopup } from '@/components/home/FirstPurchasePopup';

const A=({to,children,className}:{to:string;children:React.ReactNode;className?:string})=><a className={className} href={to} onClick={e=>{e.preventDefault();navigate(to)}}>{children}</a>;
const membership=(p:Product,key:string)=>p.category===key||(p.categoryKeys||[]).includes(key);

const premiumCategories=[
 {key:'rings',eyebrow:'THE RING EDIT',title:'טבעות מוסונייט',copy:'סוליטר, היילו ועיצובים נקיים עם נוכחות.',image:'/assets/moissanite-category-rings-v43.png',to:'/catalog?category=rings'},
 {key:'earrings',eyebrow:'LIGHT, EVERY DAY',title:'עגילי מוסונייט',copy:'סטאדים, חישוקים ועיצובים שמוסיפים אור מדויק.',image:'/assets/moissanite-category-earrings-v43.png',to:'/catalog?category=earrings'},
 {key:'necklaces',eyebrow:'CLOSE TO THE HEART',title:'שרשראות מוסונייט',copy:'תליונים וסוליטר בקווים אלגנטיים ועל־זמניים.',image:'/assets/moissanite-category-necklaces-v43.png',to:'/catalog?category=necklaces'},
 {key:'bracelets',eyebrow:'THE TENNIS LINE',title:'צמידי מוסונייט',copy:'צמידי טניס ועיצובים נוצצים בגימור רודיום.',image:'/assets/moissanite-category-bracelets-v43.png',to:'/catalog?category=bracelets'}
] as const;

export function HomePage(){
 const {products,cms}=useStore();
 const active=products.filter(p=>p.status==='active'&&p.price>0);
 const curated=pickDiverseCuratedProducts(active,8);
 const featured=active.filter(p=>p.featured);
 const edit=(featured.length>=4?featured:curated).slice(0,8);
 const ready=active.filter(p=>p.readyToShip||membership(p,'ready')).slice(0,4);
 const hero=cms.home.hero;
 const service=cms.home.serviceWays;

 // LUVERA_HOME_STORY_V120
 return <>
  {/* MOISSANITE_PREMIUM_V3 */}
  <section className="mp3-hero mp84-hero">
   <video
  className="mp3-hero-bg"
  autoPlay
  muted
  loop
  playsInline
  preload="auto"
  poster="/assets/mp873-hero-full.webp"
  aria-hidden="true"
>
  <source src="/media/hero-moissanite.mp4" type="video/mp4" />
</video>
   <div className="mp3-hero-overlay"/>
   <div className="container mp3-hero-inner">
    <div className="mp3-hero-copy mielley-sale-hero-copy">

  <span className="mp3-kicker mielley-sale-kicker">
    MOISSANITE · 925 SILVER · RHODIUM
  </span>

  <div className="mielley-sale-divider">
    <span></span><i>✦</i><span></span>
  </div>

  <h1 className="mielley-sale-title">
  <span className="sale-line sale-line-top">נראה יקר</span>
  <span className="sale-line sale-line-bottom">עולה פחות</span>
</h1>

  <div className="mielley-sale-divider mielley-sale-divider-middle">
    <span></span><i>✦</i><span></span>
  </div>

  <div className="mielley-sale-offer">
    <span className="mielley-sale-word">הנחה</span>

    <strong className="mielley-sale-percent">
      70<small>%</small>
    </strong>

    <span className="mielley-sale-up-to">עד</span>
  </div>

  <div className="mielley-sale-selected">
    על פריטים נבחרים
  </div>

  <div className="mielley-sale-divider mielley-sale-divider-small">
    <span></span><i>✦</i><span></span>
  </div>

  <p className="mielley-sale-tagline">
    המחירים ירדו. הסטייל נשאר יוקרתי.
  </p>

  <div className="mp3-hero-actions mielley-sale-actions">
    <A
      className="mp3-btn mp3-btn-primary"
      to="/catalog"
    >
      ✦ לצפייה בקולקציה
    </A>

    <A
      className="mp3-btn mp3-btn-ghost"
      to="/catalog?q=%D7%98%D7%A0%D7%99%D7%A1"
    >
      ✦ פריטים נבחרים
    </A>
  </div>

</div>
   </div>
   <div className="mp3-hero-proof">
    <div><b>✦</b><span><strong>PREMIUM</strong> MOISSANITE</span></div>
    <div><b>925</b><span><strong>STERLING</strong> SILVER</span></div>
    <div><b>Rh</b><span><strong>RHODIUM</strong> FINISH</span></div>
   </div>
  </section>

  <section className="mp3-trust">
   <div><b>01</b><strong>מוסונייט נבחר</strong><span>ברק עוצמתי ומראה יוקרתי</span></div>
   <div><b>02</b><strong>כסף סטרלינג 925</strong><span>בסיס איכותי לשימוש יומיומי</span></div>
   <div><b>03</b><strong>גימור Rhodium</strong><span>לובן, ברק וגימור נקי</span></div>
   <div><b>04</b><strong>משלוח מבוטח</strong><span>אריזה מוקפדת ומשלוח בטוח</span></div>
   <div><b>05</b><strong>שירות אישי</strong><span>ייעוץ לפני ואחרי הרכישה</span></div>
  </section>

  <section className="mp3-section mp3-discover">
   <div className="container">
    <div className="mp3-section-head">
     <div><span>DISCOVER THE COLLECTION</span><h2>לבחור לפי הרגע.<br/>להישאר עם הברק.</h2></div>
     <p>ארבע קולקציות מרכזיות, בשפה נקייה ואחידה של מוסונייט, כסף 925 וגימור רודיום.</p>
    </div>
    <div className="mp3-category-grid">
     {premiumCategories.map((item,i)=><A key={item.key} className={`mp3-category-card mp3-cat-${i+1}`} to={item.to}>
      <img src={item.image} alt={item.title}/>
      <div className="mp3-category-shade"/>
      <div className="mp3-category-copy"><span>{item.eyebrow}</span><h3>{item.title}</h3><p>{item.copy}</p><b>לצפייה בקולקציה ←</b></div>
     </A>)}
    </div>
   </div>
  </section>

  <section className="mp3-section mp3-edit mp86-option-c">
   <div className="container">
    <div className="mp3-section-head">
     <div><span>THE MIELLEY EDIT</span><h2>נבחרו כדי לבלוט.<br/>נשארו כדי ללוות.</h2></div>
     <div className="mp3-head-action"><p>עריכה נבחרת מתוך הקולקציה — קווים נקיים, פרופורציות מדויקות ונוכחות יוקרתית.</p><A to="/catalog">לכל הקטלוג ←</A></div>
    </div>
    <div className="product-grid mp3-product-grid mp86-grid">{edit.slice(0,4).map(p=><ProductCard key={p.id} product={p}/>)}</div>
   </div>
  </section>

  <section className="luvera-v120-story" aria-label="למה מוסונייט וקולקציית MIELLEY">
   <div className="luvera-v120-row">
    <div className="luvera-v120-copy">
     <span className="luvera-v120-eyebrow">WHY MOISSANITE</span>
     <h2>יותר ברק.<br/>בחירה חכמה יותר.</h2>
     <div className="luvera-v120-divider" aria-hidden="true"><span></span><i>✦</i><span></span></div>
     <p>מוסונייט מעניק ברק יוצא דופן, עמידות גבוהה ומראה יוקרתי — בחירה שנועדה לתכשיטים שאוהבים לענוד בכל יום.</p>
     <div className="luvera-v120-facts">
      <div className="luvera-v120-fact"><i>9.25</i><b>9.25 MOHS</b><small>עמידות גבוהה לשימוש יומיומי</small></div>
      <div className="luvera-v120-fact"><i>✦</i><b>EXCEPTIONAL FIRE</b><small>משחקי אור וברק מרשימים</small></div>
      <div className="luvera-v120-fact"><i>925</i><b>925 SILVER</b><small>כסף סטרלינג בגימור Rhodium</small></div>
     </div>
     <A className="luvera-v120-cta" to="/catalog">לכל תכשיטי המוסונייט <span aria-hidden="true">←</span></A>
    </div>
    <div className="luvera-v120-media">
     <img src="/assets/luvera-v120-mint-jewelry.webp" alt="תכשיטי מוסונייט וכסף 925 על רקע מנטה"/>
    </div>
   </div>

   <div className="luvera-v120-row">
    <div className="luvera-v120-media">
     <img src="/assets/luvera-v120-edit-jewelry.webp" alt="תכשיטי מוסונייט מקולקציית MIELLEY"/>
    </div>
    <div className="luvera-v120-copy ivory">
     <span className="luvera-v120-eyebrow">THE MIELLEY EDIT</span>
     <h2>תכשיטים שנועדו להישאר.</h2>
     <div className="luvera-v120-divider" aria-hidden="true"><span></span><i>✦</i><span></span></div>
     <p>בחירה מוקפדת של טבעות, עגילים, שרשראות וצמידים בקווים נקיים — פרטים קטנים שעושים את הרגעים הגדולים לבלתי נשכחים.</p>
     <A className="luvera-v120-cta light" to="/catalog">לגלות את הקולקציה <span aria-hidden="true">←</span></A>
    </div>
   </div>
  </section>

  

  {ready.length>0&&<section className="mp3-section mp3-ready">
   <div className="container">
    <div className="mp3-section-head">
     <div><span>READY TO SHIP</span><h2>לא צריך לחכות<br/>כדי לזהור.</h2></div>
     <div className="mp3-head-action"><p>דגמים נבחרים עם זמינות מהירה, אריזה מוקפדת ומשלוח מבוטח.</p><A to="/catalog?category=ready">לכל המוכנים למשלוח ←</A></div>
    </div>
    <div className="product-grid mp3-product-grid">{ready.map(p=><ProductCard key={p.id} product={p}/>)}</div>
   </div>
  </section>}

  <section className="luvera-v120-trust" aria-label="שירות ואחריות MIELLEY">
   <div className="luvera-v120-trust-item"><i aria-hidden="true">♢</i><b>אחריות מלאה על כל תכשיט</b><small>שירות וליווי בהתאם למדיניות MIELLEY</small></div>
   <div className="luvera-v120-trust-item"><i aria-hidden="true">↻</i><b>30 יום החזרה והחלפה</b><small>בהתאם למדיניות האתר</small></div>
   <div className="luvera-v120-trust-item"><i aria-hidden="true">▣</i><b>אריזת מתנה יוקרתית</b><small>אריזה מוקפדת לכל הזמנה</small></div>
   <div className="luvera-v120-trust-item"><i aria-hidden="true">▰</i><b>משלוח חינם עד הבית</b><small>בהתאם לתנאי המשלוח באתר</small></div>
  </section>

  

  <section className="mp3-final">
   <div className="container"><span>YOUR BRILLIANCE. YOUR WAY.</span><h2>הקולקציה מחכה לכם.</h2><p>טבעות, עגילים, שרשראות וצמידי מוסונייט — בעיצוב נקי, מודרני ויוקרתי.</p><A className="mp3-btn mp3-btn-primary" to="/catalog">לכל התכשיטים</A></div>
  </section>

  <FirstPurchasePopup />
 
 </>;
}
